export const WEB_APP_PATHS = {
  integrations: '/integrations',
  manageNetworks: '/admin?category=network&section=networks',
  licenseUsage: '/admin?category=tenant&section=license-usage',
  externalNetwork: '/external-network',
  externalNetworkScanProfiles: '/external-network/scan-profiles',
  internalNetworkSignalSetup: (networkId: string) =>
    `/internal-network/${encodeURIComponent(networkId)}/setup/crown-jewels`,
} as const;
